import * as React from 'react';
import isNil from 'lodash/isNil';

import { TableCell, TableRow } from 'components/table';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import Entity from 'components/entity/Entity';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';

import { __t, applyTranslations } from 'utils/language';
import { getEntityFromUser } from 'utils/view';

applyTranslations(require('./user-notifications-row-collection.i18n.json'));

import type {
  UserNotificationType,
  UserNotificationUserMetaRaw
} from 'types';

type Props = {
  orgId: number | undefined,
  notification: UserNotificationUserMetaRaw,
  onChange: (orgId: number, allowNotifications: boolean, type: UserNotificationType) => void
};

const MSG_KEY = 'user_notifications_row_collection';

class UserNotificationsRowCollection extends React.PureComponent<Props> {
  handleCheckboxClick = (): void => {
    const { orgId, notification, onChange } = this.props;

    if (isNil(orgId)) {
      return;
    }

    const allowNotifications = notification.status !== 'enabled';

    onChange(orgId, allowNotifications, 'creator_proposal');
  };

  renderEntity = (): JSX.Element => {
    const entity = getEntityFromUser({
      firstName: __t(`${MSG_KEY}.entity_value`)
    });

    return (
      <Entity>
        <EntityAvatar
          entity={entity}
          form="square"
          bordered
        />
        <EntityName
          entity={entity}
          maxLength={250}
          style={{
            maxWidth: 250,
            fontWeight: 600,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
        />
      </Entity>
    );
  };

  render(): React.ReactNode {
    const { orgId, notification } = this.props;

    return (
      <div className="user-notifications-row-collection">
        <TableRow>
          <TableCell width="big">
            {this.renderEntity()}
          </TableCell>
          <TableCell width="fill">
            &nbsp;
          </TableCell>
          <TableCell width="medium">
            <InputCheckbox
              id={`checkbox-${orgId}`}
              name={`checkbox-${orgId}`}
              checked={notification.status === 'enabled'}
              onChange={this.handleCheckboxClick}
            />
          </TableCell>
        </TableRow>
      </div>
    );
  }
}

export default UserNotificationsRowCollection;
